import api from "../../http";

export default class ApiLotteryFirstSection {
  static async getApiLotteryFirstSection(url) {
    return api.get(url)
  }
}